import { render, staticRenderFns } from "./DialogContentHistory.vue?vue&type=template&id=8b3de81a&scoped=true"
import script from "./DialogContentHistory.vue?vue&type=script&lang=js"
export * from "./DialogContentHistory.vue?vue&type=script&lang=js"
import style0 from "./DialogContentHistory.vue?vue&type=style&index=0&id=8b3de81a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b3de81a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8b3de81a')) {
      api.createRecord('8b3de81a', component.options)
    } else {
      api.reload('8b3de81a', component.options)
    }
    module.hot.accept("./DialogContentHistory.vue?vue&type=template&id=8b3de81a&scoped=true", function () {
      api.rerender('8b3de81a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DialogContentHistory.vue"
export default component.exports